import * as React from "react";
import {cx} from "emotion";

import "./checkout-button.scss";

export const CheckoutButton = (
    {
        redirectAction,
        disabled,
    }
) => (
    <div className="checkout-button-n2i">
        <div className="button">
            <div className="controls">
                <button
                    className={cx("checkout-btn", {disabled})}
                    xd-qa-type="button"
                    xd-qa-name={cx("Proceed", {disabled})}
                    onClick={() => !disabled && redirectAction({})}
                >
                    Proceed to Checkout
                </button>
            </div>
        </div>
    </div>
);
